import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../../../assets/i18n";
import { ButtonStandard, FooterActions, ToastMessage } from '../../../../components';
import Header from "../../../../components/Header/Header";
import getMessageError from '../../../../utils/getMessageError';
import getEnvParam from "../../../../utils/getEnvParam";

function Provider (props) {

	const dispatch = useDispatch();
	const lang = useSelector(state => state.language.name);
	const titlePage = messages[lang].registerTitle;
	const [typeFieldProvider, setTypeFieldProvider] = useState("Cnpj");
	const [valueFieldProvider, setValueFieldProvider] = useState("");
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
	const [toastClass, setToastClass] = useState('toast-error');

	const registerError = useSelector(state => state.register.registerError);
	const registerSuccess = useSelector(state => state.register.registerSuccess);

	const [register, setRegister] = useState({
		idFornecedor: "",
		cnpj: "",
        chapa: useSelector(state => state.authentication.chapa)
	});

	useEffect(() => {
		if(registerError.error === true) {
			let messageCode = getMessageError(registerError.data);
			setShow(true);
			setToastMessage(messages[lang].messagesCode[messageCode]);
			setToastClass('toast-error');
			dispatch({ type: "SET_REGISTER_ERROR", payload:{ error: false }});		
		}

		if(registerSuccess.success === true){
			let messageCode;
			if( registerSuccess.type === 'save' ){
				messageCode = 'register03';
			} 

			setShow(true);
			setToastMessage( messages[lang].messagesCode[messageCode]);
			setToastClass('toast-success');
			dispatch({ type: "SET_REGISTER_SUCCESS", payload:{ success: false }});

			logout();
		}
	}, [registerError, dispatch, lang, registerSuccess])

	useEffect(() => {
		if(typeFieldProvider === "Cnpj") {
			setRegister (prevState => ({...prevState, cnpj: valueFieldProvider, idFornecedor: ""}));
		}else {
			setRegister (prevState => ({...prevState, cnpj: "", idFornecedor: valueFieldProvider}));
		}
	}, [typeFieldProvider, valueFieldProvider])

	const logout = () => {
		window.location.href = getEnvParam('REACT_APP_URL_LOGIN') + 'logout';
	}

	const dispatchRegister = () => {
        if(validateFields()) {
			dispatch({
				type: "SAVE_REGISTER",
				data: { register }
			});
		}
	}

	const handleValueCnpjIdProvider = (value) => {
		setValueFieldProvider(typeFieldProvider === "Cnpj" ? cnpjMask(value) : value);
	}

	const ButtonGroupLeft = () => {
		return <>
			<ButtonStandard
				id="cd_list"
				text={messages[lang].cancel}
				textClass="text-3"
				className="btn btn-primary px-4 py-2 btn-light"
				icon="icon-bi-x text-3"
				onClick={logout}
			/>
		</>
	}

	const ButtonGroupRight = () => {
		return <>
			<ButtonStandard
				id="cd_list"
				text={messages[lang].save}
				textClass="text-3"
				className="btn btn-primary px-4 py-2 btn-light"
				icon="icon-bi-x text-3"
				onClick={() => dispatchRegister()}
			/>
		</>
	}

	const handleChecked = (event) => {
		setTypeFieldProvider(event.target.value === "0" ? "Cnpj" : `ID ${messages[lang].provider}`);
		setValueFieldProvider("");
    }

    const validateFields = () => {
        
        let message = "";
        
        if(!register.chapa || !register.chapa.length) {
            message = `${messages[lang].corporateLogin} - ${messages[lang].requiredField}`;
        
        }else if(typeFieldProvider === "Cnpj" && (!register.cnpj || !register.cnpj.length)) {
            message = `Cnpj - ${messages[lang].requiredField}`;
        
        }else if(typeFieldProvider === `ID ${messages[lang].provider}` && (!register.idFornecedor || !register.idFornecedor.length)) {
            message = `ID ${messages[lang].provider} - ${messages[lang].requiredField}`;
        }

        if(message.trim() !== "") {
			setToastClass('toast-error');
            setToastMessage(message)
            setShow(true);

			return false;
        }else{
			return true;
		}
    }

	const cnpjMask = value => {
		let cleanValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

		let base = cleanValue.substring(0, 12);
		let checkerDigits = cleanValue.substring(12, 14);

		checkerDigits = checkerDigits.replace(/[^0-9]/g, '');

		let finalValue = base + checkerDigits;

		return finalValue
			.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
			.replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3})([A-Z0-9])/, '$1.$2')
			.replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3})([A-Z0-9])/, '$1/$2')
			.replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4})(\d)/, '$1-$2');
	}

	return (
		<div className="mainPage">
			<Header />
			<div></div>
            <ToastMessage show={show} setShow={setShow} message={toastMessage} toastClass={toastClass}/>
			<Container className="pt-3 justify-content-start">
				<Row className="justify-content-between">
					<Col className="d-flex align-items-center justify-content-start">
						<span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
					</Col>
				</Row>
			</Container>
			<Container className="py-2 px-2 justify-content-between">
                <Form.Row className="px-4">
                <Col>
                    <Form.Group className="mt-1">
                    <Form.Label>{messages[lang].corporateLogin}:</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        placeholder={messages[lang].corporateLogin}
                        type="number"
                        value={register.chapa}
						disabled={true}
                        //onKeyUp={handleDoFilter}
                        onChange={event => setRegister({
                            ...register,
                            chapa: event.target.value   
                        })}
                    />
                    </Form.Group>
                </Col>
                </Form.Row>
				<div className="md-radio md-radio-inline px-4">
                    <input
                        id="1"
                        type="radio"
                        name="outputFormat"
                        defaultChecked="true"
                        value="0"
                        onChange={handleChecked}
                    />
                    <label className="text-2" htmlFor="1">Cnpj</label>
                </div>
				<div className="md-radio md-radio-inline px-4">
					<input
                        id="2"
                        type="radio"
                        name="outputFormat"
                        value="1"
                        onChange={handleChecked}
                    />
                    <label className="text-2" htmlFor="2">ID {messages[lang].provider}</label>
                </div>
			
				<Form.Row className="px-4">
				<Col>
					<Form.Group className="mt-1">
					<Form.Control
						maxLength={typeFieldProvider === "Cnpj" ? 18 : 9}
						className="text-2 border-radius-full"
						placeholder={typeFieldProvider}
						value={valueFieldProvider}
						//onKeyUp={handleDoFilter}
						onChange={event => handleValueCnpjIdProvider(event.target.value)}
					/>
					</Form.Group>
				</Col>
				</Form.Row>
			</Container>

			<FooterActions ButtonGroupLeft={ButtonGroupLeft} ButtonGroupRight={ButtonGroupRight} />
		</div>
	);
}

export default Provider;